import { css } from '@/styled-system/css';

export const tealFrame = css({
  backgroundColor: 'hpxTeal500',
  borderRadius: '4px',
  padding: '3x',
  display: 'flex',
  flexDirection: 'column',
  gap: '3x',
});

export const innerCard = css({
  backgroundColor: 'hpxWhite',
  borderRadius: '4px',
  padding: '3x',
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  '& form > div:has(> div > input[type="tel"])': {
    gridTemplateColumns: '1fr',
    xxl: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
});

export const heading = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'xs',
});

export const subheading = css({
  fontSize: 'md',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  margin: 0,
});

export const verifiedBadge = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'sm',
  color: 'hpxTeal500',
});

export const verifiedIcon = css({
  width: '16px',
  height: '16px',
});

export const submitButtonWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  marginTop: '2x',
});

export const disclaimerOnTeal = css({
  fontSize: 'tiny',
  lineHeight: '16px',
  color: 'hpxWhite',
  margin: 0,
});

export const disclaimerOnTealLink = css({
  color: 'hpxWhite',
  textDecoration: 'underline',
  fontWeight: 'bold',
  _hover: {
    textDecoration: 'none',
  },
});

export const loadingOverlay = css({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  zIndex: 'zIndexStep',
  borderRadius: '4px',
});

export const loadingSpinner = css({
  width: '32px',
  height: '32px',
  borderWidth: '3px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderTopColor: 'hpxTeal500',
  borderRadius: '50%',
  animationName: 'spin',
  animationDuration: '0.8s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
});

export const wrapperRelative = css({
  position: 'relative',
});
